import { useNavigate, useParams } from "react-router-dom";
import useMerchantDetails from "../../hooks/useMerchantDetails";
import { HashLoader } from "react-spinners";
import { CaretLeft, Storefront } from "@phosphor-icons/react";
import moment from "moment";
import useMerchantProducts from "../../hooks/useMerchantProducts";
import ProductItem from "../../components/ProductItem";

const Merchant = () => {
  const { merchantId } = useParams();
  const navigate = useNavigate();

  const { merchant: merchantDetails, isLoading } = useMerchantDetails(
    merchantId!!
  );

  const { products, isLoading: isLoadingProducts } = useMerchantProducts(
    merchantId!!
  );

  return isLoading ? (
    <div className="fixed top-0 z-50 left-0 h-screen w-screen flex items-center justify-center bg-black/20 backdrop-blur-sm">
      <HashLoader />
    </div>
  ) : merchantDetails?.data ? (
    <div className="p-10 py-5 md:py-10 px-5 md:px-10 flex flex-col gap-5">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="p-2 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300 self-start"
      >
        <CaretLeft weight="bold" />
        <span>Back</span>
      </button>
      <div>
        <div className="flex gap-4">
          <div className="w-16 h-16 flex justify-center items-center rounded-md bg-gray-50 text-visaro-orange border">
            <Storefront size={30} />
          </div>
          <div className="flex items-start flex-col text-deepBlue gap-2">
            <div>
              <div className="font-medium text-2xl">
                {merchantDetails?.data?.business_name}
              </div>
              <div className="text-sm flex items-center gap-2">
                <span>
                  Vendor since{" "}
                  {moment(merchantDetails?.data?.validated_at).fromNow()}
                </span>
                <span className="text-visaro-orange">·</span>
                <span>{merchantDetails?.data?.country_id}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      {isLoadingProducts ? (
        <div className="py-20 flex items-center justify-center flex-col gap-5">
          <HashLoader size={30} />
          <div className="text-sm animate-pulse text-center">
            Loading Merchant's Products
          </div>
        </div>
      ) : (
        products?.data &&
        (products?.data?.length > 0 ? (
          <div className="flex flex-col gap-4">
            <div className="font-medium text-lg">All Products</div>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5 md:gap-10">
              {products?.data &&
                products?.data.map((product, key) => {
                  return <ProductItem product={product} key={key} />;
                })}
            </div>
          </div>
        ) : (
          <div className="text-center text-sm text-gray-700">
            This merchant have not uploaded any product for sale yet.
          </div>
        ))
      )}
    </div>
  ) : (
    <div className="p-5 aspect-video flex items-center justify-center">
      Product Not Found
    </div>
  );
};

export default Merchant;
